export const enum ROLL_TO_OPTIONS_LABELS {
    PAYMENT = 'Payment',
    BALANCE_DUE = 'Balance Due',
    CASH_DUE = 'Cash Received',
    PROFIT = 'Profit',
    FRONT_PROFIT = 'Front Profit'
}
export const enum ROLL_TO_OPTIONS_ADJUSTMENT_TYPE {
    MONTHLY_PAYMENT = 'monthlyPayment',
    BALANCE_DUE = 'balanceDue',
    CASH_DUE = 'cashDue',
    PROFIT = 'profit'
}

export const enum ROLL_TO_OPTIONS {
    PAYMENT = 'paymentRoll',
    BALANCE_DUE = 'amountFinancedRoll',
    CASH_DUE = 'cashDueFromCustomerRoll',
    PROFIT = 'profitRoll'
}

export const ROLL_TO_OPTIONS_ADJUSTMENT_TYPE_LABEL: Record<ROLL_TO_OPTIONS_ADJUSTMENT_TYPE, string> = {
    [ROLL_TO_OPTIONS_ADJUSTMENT_TYPE.MONTHLY_PAYMENT]: 'Monthly Payment',
    [ROLL_TO_OPTIONS_ADJUSTMENT_TYPE.BALANCE_DUE]: 'Balance Due',
    [ROLL_TO_OPTIONS_ADJUSTMENT_TYPE.CASH_DUE]: 'Cash Received',
    [ROLL_TO_OPTIONS_ADJUSTMENT_TYPE.PROFIT]: 'Profit'
};
